module.exports = __webpack_public_path__ + "media/logos/spot_a_wheel-068b01bf.svg";